import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { ifProp } from 'styled-tools';

import Button from '@prisjakt/ui-button';
import { media } from '@prisjakt/ui-base';
import { layout } from '@prisjakt/ui-base/styles/variables';

type BannerProps = {
  themeColor?: string;
  logo?: string;
  inverted: boolean;
};

export const Banner = styled(Link)<BannerProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: ${layout.spacing.xSmall};
  padding-bottom: ${layout.spacing.xSmall};
  margin-bottom: ${layout.spacing.xSmall};
  margin-top: ${layout.spacing.xSmall};
  border-radius: 5px;
  font-weight: bold;

  background-color: ${props => props.themeColor || 'transparent'};
  color: #fff;

  ${ifProp(
    'logo',
    css<BannerProps>`
      padding-left: 120px;
      background-image: url(${props => props.logo});
      background-size: 100px;
      background-position-y: 50%;
      background-position-x: 20px;
      background-repeat: no-repeat;
    `
  )};

  ${ifProp(
    'inverted',
    css<BannerProps>`
      border: 2px solid
        ${props => props.themeColor || props.theme.lines.primary};
      background-color: ${props => props.theme.bg.primary};
      color: ${props => props.themeColor || props.theme.text.primary};
    `
  )};
`;

type TextProps = {
  themeColor?: string;
  inverted: boolean;
};

export const Text = styled.span<TextProps>`
  margin: 0 auto 0 ${layout.spacing.small};
  color: ${props => (props.inverted ? props.themeColor : '#fff')};
`;

type CampaignLinkProps = {
  themeColor?: string;
  inverted: boolean;
};

export const CampaignLink = styled(Button).attrs({
  color: 'primary',
  variant: 'text',
})<CampaignLinkProps>`
  /* Double selector needed to override hover color */
  && {
    color: ${props => (props.inverted ? props.themeColor : '#fff')};
  }
`;

export const LinkText = styled.span`
  ${media.mediumDown`
    display: none;
  `};
`;
